import { RAG_API_URL } from '../../../config/env';

const DASHES = /[\u2010\u2011\u2012\u2013\u2014\u2212\u2011\u2010\u2012\u2013\u2014\u2212]/g;

export const normalizeHyphensForPath = (value) => String(value || '').replace(DASHES, '-');

/** SERFF / NALF ids from LLM citations may use unicode dashes; DB uses ASCII hyphen. */
export const normalizeSerffId = (value) => normalizeHyphensForPath(value).trim().toUpperCase();

/**
 * Citation doc hints from MarkdownLite may include markdown-escaped underscores (\\_).
 * RAG resolve and source matching expect real filenames (underscores, no backslashes).
 */
export const normalizeDocHint = (value) => {
  if (value == null || value === '') return '';
  return String(value)
    .trim()
    .replace(/\\_/g, '_')
    .replace(/\\/g, '')
    .replace(/\s+/g, ' ');
};

export const getRagOrigin = () => {
  try {
    return new URL(RAG_API_URL).origin;
  } catch {
    return RAG_API_URL.replace(/\/api\/v\d\/?$/, '');
  }
};

export const sourceDocKey = (source) => {
  if (!source) return '';
  const filePath = source.file_path != null ? String(source.file_path).trim() : '';
  if (filePath) return normalizeHyphensForPath(filePath);
  const serff = source.serff_id != null ? normalizeHyphensForPath(String(source.serff_id)) : '';
  const fileName = source.file_name != null ? String(source.file_name).trim().replace(/\\/g, '/') : '';
  if (serff && fileName) return `${serff}|${fileName}`;
  return serff || fileName || '';
};

export const getPdfUrlString = (source) => {
  if (!source) return null;
  let path = source.file_path ? normalizeHyphensForPath(source.file_path) : null;
  if (!path && source.serff_id && source.file_name) {
    const serffId = normalizeHyphensForPath(source.serff_id);
    const filePart = normalizeHyphensForPath(String(source.file_name).trim()).replace(/\\/g, '/');
    if (filePart && !filePart.includes('..')) {
      path = `/static/filings/${serffId}/${filePart}`.replace(/\/+/g, '/');
    }
  }
  if (!path) return null;
  const base = getRagOrigin();
  return path.startsWith('http') ? path : `${base}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const fileNameOnly = (path) => {
  if (!path) return '';
  const i = String(path).lastIndexOf('/');
  return i >= 0 ? String(path).slice(i + 1) : String(path);
};
